import '../../../node_modules/vanilla-cookieconsent/dist/cookieconsent.css';
import './styles.css';

import * as CookieConsent from 'vanilla-cookieconsent';

import config from './config';
import CookieConsentHandler from './handler';
import { determineGeoLocation } from './helpers';

const cookieConsentHandler = new CookieConsentHandler(config, CookieConsent);

config.onFirstConsent = cookieConsentHandler.onFirstConsent;
config.onConsent = cookieConsentHandler.onConsent;
config.onChange = cookieConsentHandler.onChange;

export const run = (() => {
  let isInitialized = false;

  return async () => {
    if (isInitialized) return;

    const cookieConsentHandler = new CookieConsentHandler(config, CookieConsent);

    config.onFirstConsent = cookieConsentHandler.onFirstConsent;
    config.onConsent = cookieConsentHandler.onConsent;
    config.onChange = cookieConsentHandler.onChange;
    config.onModalShow = cookieConsentHandler.onModalShow;
    config.onModalHide = cookieConsentHandler.onModalHide;

    const geo = await determineGeoLocation();

    cookieConsentHandler.setGeo(geo);
    CookieConsent.run(config);

    window.changeCookiePreferences = CookieConsent.showPreferences;

    isInitialized = true;
  };
})();

export const showPreferences = () => {
  CookieConsent.showPreferences();
};
